(function () {
  var swiper = new Swiper('.product-additional__video__renders', {
    slidesPerView: 3,
    loop: false,
    autoplay: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      770: {
        slidesPerView: 2
      },
      1023: {
        slidesPerView: 3
      },
    },
  });
})();
